import { registerTab } from "lib/@components/tabs"
import { RateCardsTab } from "./rate-cards-tab"

registerTab({
    tab: "optimiser",
    id: "rate-cards",
    title: "Rate Cards",
    content: <RateCardsTab $lazy priority={20} />,
})
